import CrudManager from "@/components/admin/CrudManager";
import { useSeo } from "@/hooks/useSeo";

const AdminGuru = () => {
  useSeo("Kelola Guru");
  return (
    <CrudManager
      title="Guru & Staf"
      description="Tambah, edit, dan hapus data guru."
      endpoint="/teachers"
      prefix="admin-teacher"
      defaults={{ status: "GTY", order: 0 }}
      columns={[
        { name: "photo_url", image: true },
        { name: "name" },
        { name: "meta", render: (i) => `${i.position}${i.subject ? " • " + i.subject : ""} • ${i.status}` },
      ]}
      fields={[
        { name: "name", label: "Nama Lengkap", type: "text", required: true, placeholder: "Nama & gelar" },
        { name: "position", label: "Jabatan", type: "text", required: true, placeholder: "cth: Wali Kelas VI" },
        { name: "subject", label: "Mata Pelajaran", type: "text", placeholder: "cth: Matematika" },
        { name: "status", label: "Status", type: "select", options: ["PNS", "GTY", "GTT", "Aktif", "Honorer"] },
        { name: "order", label: "Urutan", type: "number", placeholder: "0" },
        { name: "photo_url", label: "Foto Guru", type: "image" },
        { name: "bio", label: "Bio Singkat", type: "textarea", rows: 3 },
      ]}
    />
  );
};

export default AdminGuru;
